import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { MenuIcon, XIcon, ShieldCheckIcon } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/fuxK5gpC3KKbVyhBpnrWVa/Picture1.png';
const NAV = [{
  to: '/',
  label: 'Home',
  end: true
}, {
  to: '/services',
  label: 'Services'
}, {
  to: '/verify',
  label: 'Verify SKR'
}, {
  to: '/contact',
  label: 'Contact'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-40 w-full border-b border-steca-100 bg-white/90 backdrop-blur" data-id="element-47" data-mp="2wkyxvs9jf3ht">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6" data-id="element-48" data-mp="31c8mcpjco0s4">
        <Link to="/" className="flex items-center gap-2" aria-label="Steca Global Security — home" data-id="element-49" data-mp="36as92s5rpglj">
          <img src={LOGO_URL} alt="Steca Global Security" className="h-10 w-auto" data-id="element-50" data-mp="3baekqx5y6os8" />
        </Link>
        <nav className="hidden items-center gap-1 md:flex" aria-label="Primary" data-id="element-51" data-mp="3fbgmplr91exw">
          {NAV.map(item => <NavLink key={item.to} to={item.to} end={item.end} className={({
          isActive
        }) => `rounded-lg px-3 py-2 text-sm font-medium transition-colors ${isActive ? 'bg-steca-50 text-steca-700' : 'text-steca-ink/70 hover:text-steca-700'}`} data-id="element-52" data-mp="2wldy3sxznbbv">
              {item.label}
            </NavLink>)}
          <Link to="/verify" className="ml-2 inline-flex items-center gap-2 rounded-lg bg-steca-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-steca-700" data-id="element-53" data-mp="3fasx7hu45qdm">
            <ShieldCheckIcon className="h-4 w-4" data-id="element-54" data-mp="35jg28hd0qk3d" />
            Confirm SKR
          </Link>
        </nav>
        <button type="button" className="inline-flex items-center justify-center rounded-lg p-2 text-steca-ink md:hidden" aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} onClick={() => setOpen(v => !v)} data-id="element-55" data-mp="30klm5n6fr9my">
          {open ? <XIcon className="h-6 w-6" data-id="element-56" data-mp="1rfnzziute7co" /> : <MenuIcon className="h-6 w-6" data-id="element-57" data-mp="1wcee40n26svg" />}
        </button>
      </div>
      {open && <nav className="border-t border-steca-100 bg-white px-4 py-3 md:hidden" aria-label="Mobile" data-id="element-58" data-mp="1hnru3lmhlcxw">
          <div className="flex flex-col gap-1" data-id="element-59" data-mp="1mml6faq1exwh">
            {NAV.map(item => <NavLink key={item.to} to={item.to} end={item.end} onClick={() => setOpen(false)} className={({
          isActive
        }) => `rounded-lg px-3 py-2 text-sm font-medium ${isActive ? 'bg-steca-50 text-steca-700' : 'text-steca-ink/70'}`} data-id="element-60" data-mp="1mki6nyz31qek">
                {item.label}
              </NavLink>)}
            <Link to="/verify" onClick={() => setOpen(false)} className="mt-1 inline-flex items-center justify-center gap-2 rounded-lg bg-steca-600 px-4 py-2 text-sm font-semibold text-white" data-id="element-61" data-mp="2t3ghuf7kefzr">
              <ShieldCheckIcon className="h-4 w-4" data-id="element-62" data-mp="hftljywhjizq" />
              Confirm SKR
            </Link>
          </div>
        </nav>}
    </header>;
}